module.exports = __webpack_public_path__ + "static/media/bg-intro-bottom-com.fd345572.png";